export const isOnSale = (pkg) => {
  if (pkg?.sale_price == null) return false;
  if (!pkg.sale_ends_at) return true;
  const ends = new Date(pkg.sale_ends_at);
  return !isNaN(ends.getTime()) && ends > new Date();
};

export const effectivePrice = (pkg) => (isOnSale(pkg) ? pkg.sale_price : pkg.price);

export const saleEndsIn = (pkg) => {
  if (!isOnSale(pkg) || !pkg.sale_ends_at) return null;
  const ms = new Date(pkg.sale_ends_at) - new Date();
  if (ms <= 0) return null;
  const hours = Math.floor(ms / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  if (hours >= 48) return `${Math.floor(hours / 24)}d ${hours % 24}h`;
  if (hours >= 1) return `${hours}h ${mins}m`;
  return `${Math.max(1, mins)}m`;
};
